import { render } from "./TransferResultsForStudentByUcoModalForm.vue?vue&type=template&id=ad2ea7d6"
import script from "./TransferResultsForStudentByUcoModalForm.vue?vue&type=script&lang=js"
export * from "./TransferResultsForStudentByUcoModalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__